import { SERVICES, DURATIONS, waLink } from "../../data";
import { Reveal, RevealImg } from "./Reveal";
import { ArrowUpRight } from "lucide-react";

export const Services = () => (
  <section id="layanan" className="relative py-24 sm:py-32 bg-[#faf7f2]">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <p className="uppercase text-xs tracking-[0.28em] text-[#8b5a2b] mb-4">
          Layanan Kami
        </p>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#2c1e16] max-w-3xl leading-tight">
          Lima treatment, satu tujuan — tubuh yang kembali tenang.
        </h2>
        <p className="mt-5 max-w-xl text-[#5c4033] leading-relaxed">
          Setiap treatment tersedia dalam pilihan durasi 60, 90, dan 120 menit
          per sesi.
        </p>
      </Reveal>

      <div className="mt-20 space-y-24">
        {SERVICES.map((s, i) => {
          const flip = i % 2 === 1;
          return (
            <div
              key={s.slug}
              data-testid={`service-${s.slug}`}
              className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center"
            >
              <RevealImg
                className={`relative ${flip ? "lg:order-2" : ""}`}
              >
                <div className="relative overflow-hidden arch bg-[#f2ece4] aspect-[4/5] group">
                  <img
                    src={s.image}
                    alt={`${s.name} - Javanese Spa Jogja`}
                    className={`h-full w-full object-cover object-left transition-transform duration-700 group-hover:scale-105`}
                  />
                  <span className="absolute bottom-5 left-5 rounded-full bg-[#faf7f2]/90 backdrop-blur px-4 py-1.5 text-xs uppercase tracking-[0.15em] text-[#5c4033]">
                    {s.tag}
                  </span>
                </div>
              </RevealImg>

              <Reveal
                delay={0.1}
                className={flip ? "lg:order-1" : ""}
              >
                <span className="font-display italic text-2xl text-[#b8862f]">
                  0{i + 1}
                </span>
                <h3 className="font-display text-3xl sm:text-4xl text-[#2c1e16] mt-2 leading-tight">
                  {s.name}
                </h3>
                <p className="mt-4 text-[#5c4033] leading-relaxed max-w-md">
                  {s.desc}
                </p>

                <div className="mt-6 flex flex-wrap gap-3">
                  {DURATIONS.map((d) => (
                    <span
                      key={d}
                      className="rounded-full border border-[#e5d9c5] px-4 py-1.5 text-sm text-[#5c4033]"
                    >
                      {d}
                    </span>
                  ))}
                </div>

                <div className="mt-8 flex items-center gap-5">
                  <span className="font-display text-2xl text-[#2c1e16]">
                    Hubungi untuk harga
                  </span>
                </div>

                <a
                  href={waLink(
                    `Halo Javanese Spa Jogja, saya tertarik dengan ${s.name}. Boleh info harga & booking?`
                  )}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={`service-book-${s.slug}`}
                  className="group mt-6 inline-flex items-center gap-2 rounded-full bg-[#5c4033] text-[#faf7f2] px-6 py-3 text-sm hover:bg-[#2c1e16] transition-colors"
                >
                  Booking {s.name}
                  <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </a>
              </Reveal>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);
